/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IncludedDocuments {
    NonArchived = 0,
    All = 1,
    Archived = 2
}

export function IncludedDocumentsFromJSON(json: any): IncludedDocuments {
    return IncludedDocumentsFromJSONTyped(json, false);
}

export function IncludedDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncludedDocuments {
    return json as IncludedDocuments;
}

export function IncludedDocumentsToJSON(value?: IncludedDocuments | null): any {
    return value as any;
}

